import React, { useEffect, useState, useRef } from "react";
import { HashLink as Link } from 'react-router-hash-link';
import Swal from "sweetalert2";
import Header from '../components/header/header';
import Footer from '../components/footer/footer';
import $ from 'jquery';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import "slick-carousel/slick/slick.css"; // Use packaged version
import "slick-carousel/slick/slick-theme.css"; // Use packaged theme
import "slick-carousel";
import { Modal } from 'bootstrap'; // Import Bootstrap Modal

// import { FaBolt, FaChartLine, FaCashRegister } from 'react-icons/fa';
import { FaCheckCircle, FaCodeBranch, FaShieldAlt, FaBolt, FaChartLine,
        FaCashRegister,FaPalette, FaChartBar,FaHistory,FaMapMarkerAlt,
        FaFileExport, FaCode, FaLink, FaFileCode, FaBook  } from 'react-icons/fa';
const Homepage = () => {
  const headerRef = useRef();
  const handleOpenLogin = () => {
    if (headerRef.current) {
      headerRef.current.showLoginModal();
    }
  };
  const handleOpenRegister = () => {
    if (headerRef.current) {
      headerRef.current.showRegisterModal();
    }
  };
  

   useEffect(() => {
    const initSliders = () => {
      // Ensure jQuery and Slick are loaded before running this code
      if (window.jQuery && window.jQuery.fn.slick) {
        // Market slide js
        $('.product-main').slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 3000,
          speed: 2000,
          arrows: false,
          centerMode: true,
          centerPadding: '0px',
          focusOnSelect: true,
          responsive: [
            {
              breakpoint: 576,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
              },
            },
          ]
        });

        // Review slide js
        $('.review-main').slick({
          slidesToShow: 2,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 3000,
          speed: 2000,
          arrows: false,
          centerMode: true,
          centerPadding: '0px',
          focusOnSelect: true,
          responsive: [
            {
              breakpoint: 576,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              },
            },
          ]
        });

        // Blog slide js
        $('.blog-main').slick({
          slidesToShow: 2,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 3000,
          speed: 2000,
          arrows: false,
          centerMode: true,
          centerPadding: '0px',
          focusOnSelect: true,
          responsive: [
            {
              breakpoint: 576,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
              },
            },
          ]
        });

        // Smooth scroll for anchors
     // In your initSliders function, modify the smooth scroll code:
      var html_body = $('html, body');
      $('.navbar a, .scroll-down a, .backtotop a').on('click', function(e) {
        // Check if this is an internal hash link
        if (this.hash && window.location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && window.location.hostname === this.hostname) {
          e.preventDefault();
          
          // Store hash
          var hash = this.hash;
          
          // Animate scroll
          html_body.animate({
            scrollTop: $(hash).offset().top - 65
          }, 800, function() {
            // Add hash to URL after scroll (default click behavior)
            window.location.hash = hash;
          });
        }
      });

      // Add this to handle initial page load with hash
      if (window.location.hash) {
        setTimeout(function() {
          html_body.animate({
            scrollTop: $(window.location.hash).offset().top - 65
          }, 800);
        }, 1000); // Delay to account for page load
      }

        // Preloader
        $(window).on('load', function () {
          $('.preloader').delay(1000).fadeOut(1000);
        });
        setTimeout(() => {
          $('.preloader').fadeOut(1000);
        }, 2000);
        // Scroll effects
        $(window).scroll(function () {
          var scrolling = $(this).scrollTop();
          var stikey = $('.sticky-top');

          if (scrolling >= 100) {
            $(stikey).addClass("nav-bg");
          } else {
            $(stikey).removeClass("nav-bg");
          }
          if (scrolling > 280) {
            $('.backtotop').fadeIn(500);
          } else {
            $('.backtotop').fadeOut(500);
          }
        });
      }
    };

    // Check if jQuery is loaded
    if (!window.jQuery) {
      const jqueryScript = document.createElement('script');
      jqueryScript.src = 'https://code.jquery.com/jquery-3.6.0.min.js';
      jqueryScript.async = true;
      document.body.appendChild(jqueryScript);

      jqueryScript.onload = () => {
        // Load Slick after jQuery
        const slickScript = document.createElement('script');
        slickScript.src = '/js/slick.min.js'; // Ensure this path is correct
        document.body.appendChild(slickScript);

        slickScript.onload = () => {
          // Initialize sliders after both jQuery and Slick are loaded
          initSliders();

          // Load custom.js for other functionality
          const customScript = document.createElement('script');
          customScript.src = '/js/custom.js'; // Ensure this path is correct
          document.body.appendChild(customScript);
        };
      };
    } else {
      // If jQuery is already loaded, just check for Slick
      if (window.jQuery.fn.slick) {
        initSliders();
      } else {
        const slickScript = document.createElement('script');
        slickScript.src = '/js/slick.min.js';
        slickScript.onload = initSliders;
        document.body.appendChild(slickScript);
      }
    }

    return () => {
      // Cleanup sliders when component unmounts
      if (window.jQuery && window.jQuery.fn.slick) {
        $('.product-main, .review-main, .blog-main').slick('unslick');
      }
    };
  }, []);


    const [email, setEmail] = useState('');
    const [subscriber_website, setsubscriber_website] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const handleSubmit = async (event) => {
        setsubscriber_website('RefMex');
        event.preventDefault();
        setIsSubmitting(true);
        try {
            const response = await fetch(`${process.env.REACT_APP_RECEIPT_URL}/subscribe`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
               body: JSON.stringify({ email, subscriber_website: 'RefMex' }), 
            });

            if (response.ok) {
                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: 'Subscription successful!',
                    showConfirmButton: false,
                    timer: 2000
                });
                setEmail('');
            } else {
                const errorResponse = await response.text();
                let errorMessage;
                try {
                    const jsonResponse = JSON.parse(errorResponse);
                    errorMessage = jsonResponse.message;
                } catch (e) {
                    errorMessage = 'An unknown error occurred';
                }
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: `Failed to subscribe: ${errorMessage}`,
                    showConfirmButton: true
                });
            }
        } catch (error) {
            console.error('Error subscribing:', error);
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'An error occurred. Please try again later.',
                showConfirmButton: true
            });
        } finally {
            setIsSubmitting(false);
        }
    };
 

    // Update your handlePlanClick function to use React state for modal control
const [showModal, setShowModal] = useState(false);

const handlePlanClick = (planName) => {
  formData.username = '';
  formData.email = '';
  formData.description = '';

  setFormData(prev => ({
    ...prev,
    plan: planName
  }));
  // setShowModal(true);
};

const handleCloseModal = () => {
  setShowModal(false);
  setFormData(prev => ({ ...prev, plan: '' })); // Reset plan when closing
};

const [formData, setFormData] = useState({
  username: '',
  email: '',
  description: '',
  plan: '' // This will track which plan was selected (if any)
});

const [isContactSubmitting, setIsContactSubmitting] = useState(false);

// Update the handleSubmit function for the contact form
const handleContactSubmit = async (event) => {
  event.preventDefault();
  setIsContactSubmitting(true);

  try {
    const subject = formData.plan 
      ? `Someone wants to buy ${formData.plan} plan of RefMex` 
      : 'Someone contacted you from RefMex.com';

    const response = await fetch(`${process.env.REACT_APP_RECEIPT_URL}/contact`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        ...formData,
        subject
      }),
    });

    if (response.ok) {
      Swal.fire({
        position: 'center',
        icon: 'success',
        title: 'Message sent successfully!',
        showConfirmButton: false,
        timer: 2000
      });
      // Reset form
      setFormData({
        username: '',
        email: '',
        description: '',
        plan: ''
      });
    } else {
      const errorResponse = await response.text();
      let errorMessage;
      try {
        const jsonResponse = JSON.parse(errorResponse);
        errorMessage = jsonResponse.message;
        setFormData({
        username: '',
        email: '',
        description: '',
        plan: ''
      });
      } catch (e) {
        errorMessage = 'An unknown error occurred';
        setFormData({
        username: '',
        email: '',
        description: '',
        plan: ''
      });
      }
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: `Failed to send message: ${errorMessage}`,
        showConfirmButton: true
      });
      setFormData({
        username: '',
        email: '',
        description: '',
        plan: ''
      });
    }
  } catch (error) {
    console.error('Error sending message:', error);
    Swal.fire({
      position: 'center',
      icon: 'error',
      title: 'An error occurred. Please try again later.',
      showConfirmButton: true
    });
    setFormData({
        username: '',
        email: '',
        description: '',
        plan: ''
      });
  } finally {
    setIsContactSubmitting(false);
  }
};

// Add this function to handle plan selection



return(
    <>
    <style>
      {
        `
        .check-style {
            color: #0553d9 !important;
            font-size: 18px !important;
            padding-right: 4px !important;
        }
        
        .slider-text{
          
            font-size: 14px !important;
            color: #666 !important;
            padding-bottom: 14px !important;
        }

        .questions{
            font-size:18px !important;
            color: #666 !important;
            padding-bottom: 18px !important;
        }
        .product-txt p {
            color: #787878;
            /* font-family: pr; */
            line-height: 27px;
            font-size: 17px;
            padding-bottom: 30px;
        }
        .question-span{
          display: flex !important;
          align-items: center !important;
          font-size: 20px !important;
        }

        `
      }
    </style>
    {/* <style>
  {
    `
    .check-style {
        color: #0553d9 !important;
        font-size: 18px !important;
        padding-right: 4px !important;
    }
    
    .slider-text{
        font-size: 14px !important;
        color: #666 !important;
        padding-bottom: 14px !important;
    }

    .questions{
        font-size:18px !important;
        color: #666 !important;
        padding-bottom: 18px !important;
    }
    .product-txt p {
        color: #787878 !important;
        line-height: 27px !important;
        font-size: 17px !important;
        padding-bottom: 30px !important;
    }
    .question-span{
      display: flex !important;
      align-items: center !important;
      font-size: 20px !important;
    }

    
    @media (max-width: 1200px) {
      #developer .product-txt {
        padding-right: 15px !important;
      }
    }

    @media (max-width: 992px) {
      .banner-txt h3 {
        font-size: 2.2rem !important;
      }
      
      .team-item h3 {
        font-size: 1.2rem !important;
      }
      
      #analytics .product-txt {
        margin-bottom: 30px !important;
      }
      
      .price-table {
        margin-bottom: 30px !important;
      }
    }

    @media (max-width: 768px) {
      .banner-img img {
        max-width: 100% !important;
        height: auto !important;
      }
      
      .banner-txt h3 {
        font-size: 1.8rem !important;
      }
      
      .question-span {
        font-size: 16px !important;
      }
      
      .product-slider h3 {
        font-size: 1.2rem !important;
      }
      
      .review-item .comment p {
        font-size: 14px !important;
      }
      
      #final-cta h2 {
        font-size: 2rem !important;
      }
      
      .over-item {
        margin-bottom: 30px !important;
      }
    }

    @media (max-width: 576px) {
      body {
        overflow-x: hidden;
      }
      
      .banner-txt h3 {
        font-size: 1.5rem !important;
      }
      
      .banner-buttons {
        flex-direction: column;
      }
      
      .banner-buttons a {
        margin-bottom: 10px !important;
        width: 100% !important;
      }
      
      .team-item {
        margin-bottom: 30px !important;
      }
      
      .product-slider {
        padding: 15px !important;
      }
      
      .review-item {
        margin: 0 10px !important;
      }
      
      #contact .col-lg-4, 
      #contact .col-lg-8 {
        padding: 0 15px !important;
      }
      
      #final-cta h2 {
        font-size: 1.8rem !important;
      }
      
      .cta-buttons a {
        width: 100%;
        margin-bottom: 10px !important;
      }
      
  
      img {
        max-width: 100% !important;
        height: auto !important;
      }
      
      
      #about img {
        height: auto !important;
      }
      
      #developer img {
        position: relative !important;
        transform: none !important;
        max-height: 300px !important;
        margin: 0 auto !important;
        display: block !important;
      }
      
      #analytics img {
        position: relative !important;
        transform: none !important;
        max-height: 300px !important;
        margin: 20px auto !important;
        display: block !important;
      }
    }

   
    html, body {
      max-width: 100% !important;
      overflow-x: hidden !important;
    }
    
   
    .container-fluid {
      padding-right: 15px !important;
      padding-left: 15px !important;
      margin-right: auto important;
      margin-left: auto important;
    }
    
    
    .product-main, .review-main, .blog-main {
      overflow: hidden important;
    }
    `
  }
</style> */}
     <Header ref={headerRef} />
    <div className="container-fluid">
        <div className="preloader">
            <div className="frame">
                <div className="center">
                    <div className="dot-1"></div>
                    <div className="dot-2"></div>

                </div>
            </div>
        </div>      
    

    {/* BANNER AREA START  */}
    <section id="banner">
        <div className="design-layer"></div>
        <div className="backtotop">
            <a href="#banner"><i className="fa fa-arrow-up" aria-hidden="true"></i></a>
        </div>
        <div className="container zindex">
            <div className="row">
                <div className="col-lg-6 banner-txt">
                   <h3>“Turn Happy Customers Into Your Best Marketers.”</h3>
                    <p>Refmex helps stores grow through word-of-mouth. Share referral links via QR codes or messages — customers earn loyalty points for every successful referral, and their friends enjoy instant discounts.</p>
                 <div className="button-group banner-buttons d-flex">
                
                <a
                  className="nav-link bor"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    const contactModal = new Modal(document.getElementById('ContactModal'), {
                      backdrop: true,
                      keyboard: true
                    });
                    contactModal.show();
                  }}
                >
                  Book A Free Trial
                </a>
                    {/* <a href="#" >Book a Demo</a> */}
                  </div>

                </div>
                <div className="col-lg-6">
                    <div className="banner-img">
                        <img src="images/banner-image.png" alt="banner-img" className="banner-image"/>
                    </div>
                </div>
            </div>
        </div>
        <div
          className="modal fade"
          id="ContactModal"
          tabIndex="-1"
          aria-labelledby="ContactModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="ContactModalLabel">Contact Us</h5>
                <button
                  type="button"
                  className="close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <form
                onSubmit={async (e) => {
                  e.preventDefault();
                  const username = e.target.username.value;
                  const email = e.target.email.value;
                  const message = e.target.message.value;
        
                  try {
                    const response = await fetch(`${process.env.REACT_APP_RECEIPT_URL}/contact`, {
                      method: "POST",
                      headers: { "Content-Type": "application/json" },
                      body: JSON.stringify({
                        username,
                        email,
                        description: message,
                        subject: "Contact message from Refmex site"
                      }),
                    });
        
                    if (response.ok) {
                      Swal.fire({
                        position: "center",
                        icon: "success",
                        title: "Message sent successfully!",
                        showConfirmButton: false,
                        timer: 2000,
                      });
                      e.target.reset();
                      const modalEl = document.getElementById('ContactModal');
                      const modal = Modal.getInstance(modalEl);
                      modal.hide();
                    } else {
                      const errText = await response.text();
                      Swal.fire({
                        icon: "error",
                        title: "Failed to send message",
                        text: errText || "Please try again later",
                      });
                    }
                  } catch (err) {
                    console.error(err);
                    Swal.fire({
                      icon: "error",
                      title: "An error occurred",
                      text: "Please try again later",
                    });
                  }
                }}
              >
                <div className="modal-body">
                  <div className="mb-3">
                    <input
                      type="text"
                      name="username"
                      className="form-control box-bg"
                      placeholder="Your Name"
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <input
                      type="email"
                      name="email"
                      className="form-control box-bg"
                      placeholder="Your Email"
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <textarea
                      name="message"
                      className="form-control box-bg"
                      placeholder="Your Message"
                      rows="3"
                      required
                    ></textarea>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn dropboxx2"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </button>
                  <button type="submit" className="btn dropboxx2">
                    Send Message
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
    </section>
    {/* BANNER AREA ENDS */}



    {/* Section 2 The Problem Starts */}

     <section id="about">
        <div className="container">
          <div className="row header-text text-center">
            <div className="col-lg-12">
              {/* <h3>WHY <span>F</span>EEDMEX</h3> */}
              <h3 className="text-uppercase heading-mobile" >Still relying on ads to bring people<span>i</span>n?</h3>
            </div>
          </div> 
          <div className="row review-pa">
            <div className="col-lg-10 col-md-12 m-auto ">
              <div className="row">
                <div className="col-lg-4 col-sm-8 m-sm-auto m-md-auto m-lg-auto  col-md-5 text-center">
                    <img src="images/guessing.png" alt="about-img" className="guessing-image" style={{objectFit:'contain', height:'455px'}}/>
                </div>
                <div className="col-lg-1 col-md-1"></div>
                <div className="col-lg-7 col-md-6">
                  <div className="about-txt">
                    {/* <span className="separet-span">Still using paper surveys or guessing what customers think?</span> */}
                       {/* <h3>Still using paper surveys or guessing what customers think?</h3> */}
                    {/* <h3>#1 Animation Studio Presents</h3> */}
                    <p className="mt-4" >Paid marketing can be expensive — and forgettable.</p>
                    <p className="separate-p tab-hider">Refmex gives you a simple, automated way to turn your loyal customers into brand ambassadors — directly at the point of sale.</p>
                   
                  <p className="question-span">
                    <FaBolt style={{color: "#0553d9", marginRight: "4px"}} /> Instant referrals
                  </p>
                  <p className="question-span">
                    <FaChartLine style={{color: "#0553d9", marginRight: "4px"}} /> Built-in loyalty tracking
                  </p>
                  <p className="question-span">
                    <FaCashRegister style={{color: "#0553d9", marginRight: "4px"}} /> QR and link sharing made easy
                  </p>           


                    
                    {/* <a href="#">Read More</a> */}
                  </div>
                </div>
              </div>
            </div>
           
          </div>
        </div>
      </section>

    {/* The Problem Ends */}




   {/* How it works AREA START */}
      <section id="team">
        <div className="container">
          <div className="row header-text text-center">
            <div className="col-lg-12">
              {/* <h3>HOW IT <span>W</span>ORKS</h3> */}
              <h3 className="text-uppercase heading-mobile" >From Referral to Reward — In 3 Simple <span>s</span>teps</h3>
            </div>
          </div>
          {/* <div className="row text-center">
            <div className="col-lg-12">
              <h3 className="mt-3" >“From Refmex to Fixes — In 3 Simple Steps”</h3>
            </div>
          </div> */}
          <div className="row review-pa">
            <div className="col-lg-3 col-md-3 col-sm-4 m-auto team-item text-center"  >
              <img src="images/pos.png" alt="team-member" className="pos-img"  style={{objectFit:'contain', height:'306px'}} />
              <h3>Step 1: Share Your QR or Link</h3>
              <p>Customers scan your in-store QR code or tap a shared link — no app needed.</p>
            </div>
            <div className="col-lg-3 col-md-3 col-sm-4 m-auto team-item text-center"  >
              <img src="images/build-form.png" className="build-form-img" alt="team-member" style={{objectFit:'contain', height:'306px'}} />
              <h3>Step 2: Refer Friends & Family</h3>
              <p>They add a friend’s name and phone number to send them a discount invitation.</p>
            </div>
            <div className="col-lg-3 col-md-3 col-sm-4 m-auto team-item text-center" >
              <img src="images/insights.png" alt="team-member" className="insights-img"  style={{objectFit:'contain', height:'306px'}} />
               <h3>Step 3: Earn Loyalty Points Instantly</h3>
              <p>Each referral earns loyalty points redeemable at your store — a win-win for everyone.</p>
            </div>
          </div>
        </div>
      </section>
      {/* HOw it works AREA ENDS */}


    {/* ========== SECTION 4: TAILORED FOR YOUR BUSINESS START ========== */}
  <section id="product">
        <div className="container">
          <div className="row header-text text-center">
            <div className="col-lg-12">
              <h3 className="text-uppercase heading-mobile" >TAILORED FOR YOUR <span>B</span>USINESS</h3>
            </div>
          </div>
          <div className="row text-center">
            <div className="col-lg-12">
              <h3 className="mt-3" >“Referral Made Simple. Rewards Made Smarter.”</h3>
               <h6 className="mt-3" >Every business is unique — and so are your customers.</h6>
            </div>
          </div>
          <div className="row review-pa" >
            <div className="col-lg-12">
              <div className="product-main">
                <div className="col-lg-12">
                  <div className="product-slider text-center">
                    <div className="pro-img">
                      <img src="images/restaurant.png" alt="product-img"/>
                    </div>
                    <div>
                      <h3>Restaurants </h3>
                      {/* <a href="#">Watch Now</a> */}
                      <span className="slider-text">Food quality, staff behavior, wait times</span>
                    </div>
                    {/* <div className="row pro-info">
                      <div className="col-lg-6 col-6 col-sm-5">
                        <span>Ratings</span>
                      </div>
                      <div className="col-lg-6 col-6 stars col-sm-7">
                        <i className="fa fa-star" aria-hidden="true"></i>
                        <i className="fa fa-star" aria-hidden="true"></i>
                        <i className="fa fa-star" aria-hidden="true"></i>
                        <i className="fa fa-star" aria-hidden="true"></i>
                      </div>
                    </div> */}
                  </div>
                </div>
                <div className="col-lg-12">
                  <div className="product-slider text-center">
                    <div className="pro-img">
                      <img src="images/hair-cut.png" alt="product-img"/>
                    </div>
                    <div >
                      <h3>Salons</h3>
                      {/* <a href="#">Watch Now</a> */}
                      <span className="slider-text">Stylist rating, cleanliness, appointment handling</span>
                    </div>
                    {/* <div className="row pro-info">
                      <div className="col-lg-6 col-sm-5 col-6">
                        <span>Ratings</span>
                      </div>
                      <div className="col-lg-6 col-6 col-sm-7 stars">
                        <i className="fa fa-star" aria-hidden="true"></i>
                        <i className="fa fa-star" aria-hidden="true"></i>
                        <i className="fa fa-star" aria-hidden="true"></i>
                        <i className="fa fa-star" aria-hidden="true"></i>
                      </div>
                    </div> */}
                  </div>
                </div>
                <div className="col-lg-12">
                  <div className="product-slider text-center">
                    <div className="pro-img">
                      <img src="images/spa.png" alt="product-img"/>
                    </div>
                    <div >
                      <h3>Spa</h3>
                      {/* <a href="#">Watch Now</a> */}
                      <span className="slider-text">Service Refmex, relaxation experience</span>
                    </div>
                    {/* <div className="row pro-info">
                      <div className="col-lg-6 col-sm-5 col-6">
                        <span>Ratings</span>
                      </div>
                      <div className="col-lg-6 col-6 col-sm-7 stars">
                        <i className="fa fa-star" aria-hidden="true"></i>
                        <i className="fa fa-star" aria-hidden="true"></i>
                        <i className="fa fa-star" aria-hidden="true"></i>
                        <i className="fa fa-star" aria-hidden="true"></i>
                      </div>
                    </div> */}
                  </div>
                </div>
                <div className="col-lg-12">
                  <div className="product-slider text-center">
                    <div className="pro-img">
                      <img src="images/dentist.png" alt="product-img"/>
                    </div>
                    <div >
                      <h3>Dental Clinics</h3>
                      {/* <a href="#">Watch Now</a> */}
                      <span className="slider-text">Comfort, professionalism, experience</span>
                    </div>
                    {/* <div className="row pro-info">
                      <div className="col-lg-6 col-sm-5 col-6">
                        <span>Ratings</span>
                      </div>
                      <div className="col-lg-6 col-sm-7 col-6 stars">
                        <i className="fa fa-star" aria-hidden="true"></i>
                        <i className="fa fa-star" aria-hidden="true"></i>
                        <i className="fa fa-star" aria-hidden="true"></i>
                        <i className="fa fa-star" aria-hidden="true"></i>
                      </div>
                    </div> */}
                  </div>
                </div>
                <div className="col-lg-12">
                  <div className="product-slider text-center">
                    <div className="pro-img">
                      <img src="images/aesthetics.png" alt="product-img"/>
                    </div>
                    <div >
                      <h3>Aesthetic Clinics</h3>
                      {/* <a href="#">Watch Now</a> */}
                      <span className="slider-text">Consultation, results, facility experience</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <div className="row text-left mt-5">
            <div className="col-lg-12">
              <h5>Each form is designed by industry experts to ask what matters.</h5>
            </div>
          </div> */}
        </div>
  </section>
    {/* ========== SECTION 4: TAILORED FOR YOUR BUSINESS END ========== */}


{/* ========== SECTION 5: CUSTOM Refmex BUILDER START ========== */}
{/* <section id="custom-builder">
  <div className="container">
     <div className="row header-text text-center">
        <div className="col-lg-12">
          <h3>Custom Refmex <span>B</span>UILDER</h3>
        </div>
      </div>
      <div className="row text-center">
        <div className="col-lg-12">
          <h3 className="mt-3" >“Need Custom Questions? No Problem.”</h3>
        </div>
      </div>
    <div className="row align-items-center review-pa">
      <div className="col-lg-8">
        <div className="product-txt">
        <p className="mb-4 mt-4">
          Drag-and-drop form builder with conditional logic, branding options, and support for multiple languages. 
          Build forms that speak your customers' language — and your brand voice.
        </p>
        <p className="question-span">
          <FaPalette  style={{ color: "#0553d9", marginRight: "4px" }} /> Brand it your way
        </p>
        <p className="question-span">
          <FaCodeBranch style={{ color: "#0553d9", marginRight: "4px" }} /> Add branching logic
        </p>
        <p className="question-span">
          <FaShieldAlt style={{ color: "#0553d9", marginRight: "4px" }} /> Secure and private
        </p>
      </div>
      </div>
      <div className="col-lg-4">
        <div className="form-builder-preview">
          <img 
            src="images/template-builder.png" 
            alt="Feedmex Form Builder Interface" 
            className="img-fluid" 
          />
        </div>
      </div>
    </div>
  </div>
</section> */}

{/* ========== SECTION 5: CUSTOM Refmex BUILDER END ========== */}

  {/* ========== SECTION 4: Developer-Friendly Integration ========== */}
  {/* <section id="custom-builder">
        <div className="container">
          <div className="row header-text text-center">
            <div className="col-lg-12">
              <h3>DEVELOPER-FRIENDLY <span>I</span>NTEGRATION</h3>
            </div>
          </div>
          <div className="row text-center">
            <div className="col-lg-12">
              <h3 className="mt-3" >“Built for Developers. Loved by Businesses.”</h3>
            </div>
          </div>
          <div className="row review-pa">
            <div className="col-lg-12">
                <div className="row">
                  <div className="col-lg-8 col-md-7 product-txt">
                    <h5>Whether you’re running a single outlet or a multi-branch chain, FeedMex offers:</h5>
                    <div className="mt-4">
                      <p className="question-span">
                        <FaCode style={{color: "#0553d9", marginRight: "4px"}} /> Clean REST APIs
                      </p>
                      <p className="question-span">
                        <FaLink style={{color: "#0553d9", marginRight: "4px"}} /> Webhooks & callbacks
                      </p>
                      <p className="question-span">
                        <FaFileCode style={{color: "#0553d9", marginRight: "4px"}} /> Sample integration code
                      </p>
                      <p className="question-span">
                        <FaBook style={{color: "#0553d9", marginRight: "4px"}} /> Live API documentation
                      </p>
                    </div>
                      <div className="row mb-5 px-2" >
                        <div className="col-12" >
                           <h5>No SDK bloat. No vendor lock-in. Just easy integration.</h5>
                           <div style={{marginBottom:'14px',marginTop:'14px'}} > <a href="/ApiDocumentation">Explore the Api Docs</a></div>
                        </div>
                      </div>
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <img  style={{
                        position: 'absolute',
                        top: '50%',
                        right: '0',
                        transform: 'translateY(-50%)',
                        maxHeight: '120%'
                      }} 
                  src="images/developer.png"/>
                  </div>
                </div>
            </div>
          </div>
        </div>
  </section> */}


<section id="product">
  <div className="container">
    <div className="row header-text text-center">
      <div className="col-lg-12">
        <h3 className="text-uppercase heading-mobile"  >DEVELOPER-FRIENDLY <span>I</span>NTEGRATION</h3>
      </div>
    </div>
    <div className="row text-center">
      <div className="col-lg-12">
        <h3 className="mt-3">“Built for Developers. Loved by Businesses.”</h3>
      </div>
    </div>
    <div className="row review-pa">
      <div className="col-12">
        <div className="row align-items-center">
          <div className="col-12 col-md-4 order-1 order-md-2 text-center mb-4 mb-md-0">
            <img
              src="images/developer.png"
              alt="Developer Illustration"
              style={{ maxHeight: '100%', width: '100%' }}
            />
          </div>
          <div className="col-12 col-md-8 order-2 order-md-1 product-txt">
            <h5>Whether you manage a single branch or a nationwide chain, Refmex offers:</h5>
            <div className="mt-4">
              <p className="question-span">
                <FaCode style={{ color: "#0553d9", marginRight: "4px" }} /> REST APIs for POS & CRM integration
              </p>
              <p className="question-span">
                <FaLink style={{ color: "#0553d9", marginRight: "4px" }} /> Webhooks for referral updates
              </p>
              <p className="question-span">
                <FaFileCode style={{ color: "#0553d9", marginRight: "4px" }} /> Ready-to-use code samples
              </p>
              <p className="question-span">
                <FaBook style={{ color: "#0553d9", marginRight: "4px" }} /> Live documentation
              </p>
            </div>
            <div className="row mb-5 px-2">
              <div className="col-12">
                <h5>No complicated SDKs. No vendor lock-in. Just easy integration.</h5>
                <div className="question-span" style={{ marginBottom: '14px', marginTop: '14px' }}>
                  {/* <a  href="/ApiDocumentation">  Explore the Api Docs</a> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>


    {/* ========== SECTION 4:Developer-Friendly Integration ========== */}


 {/* REVIEW AREA START */}
      {/* <section id="review">
        <div className="container">
          <div className="row header-text text-center">
            <div className="col-lg-12">
              <h3 className="text-uppercase heading-mobile"  >REAL Refmex. REAL <span>R</span>ESULTS</h3>
            </div>
          </div>
          <div className="row review-pa ">
            <div className="col-lg-12">
              <div className="review-main">
                <div className="col-lg-12">
                  <div className="review-item">
                    <div className="comment">
                      <p><i className="fa fa-quote-left" aria-hidden="true"></i>FeedMex helped us discover what our customers truly think. With real Refmex, we’ve boosted retention by over 20%.<i className="fa fa-quote-right" aria-hidden="true"></i></p>
                    </div>
                    <div className="user">
                      <div className="row">
                        <div className="col-lg-4 col-sm-4 user-img">
                          <img src="images/testimonial.png" alt="user-img"/>
                        </div>
                        <div className="col-lg-7 col-sm-7 user-txt">
                         <h3>Yusuf Khan</h3>
                          <div className="star2">
                            <i className="fa fa-star" aria-hidden="true"></i>
                            <i className="fa fa-star" aria-hidden="true"></i>
                            <i className="fa fa-star" aria-hidden="true"></i>
                            <i className="fa fa-star" aria-hidden="true"></i>
                            <i className="fa fa-star" aria-hidden="true"></i>
                          </div>
                          <span>5 Days ago</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-12">
                  <div className="review-item">
                    <div className="comment">
                      <p><i className="fa fa-quote-left" aria-hidden="true"></i>Setup took just an afternoon. We've been collecting real, useful insights ever since — simple, smooth, and effective.<i className="fa fa-quote-right" aria-hidden="true"></i></p>
                    </div>
                    <div className="user">
                      <div className="row">
                        <div className="col-lg-4 col-sm-4 user-img">
                          <img src="images/testimonial1.png" alt="user-img"/>
                        </div>
                        <div className="col-lg-7 col-sm-7 user-txt">
                          
                          <h3>Anjali Rao</h3>
                          <div className="star2">
                            <i className="fa fa-star" aria-hidden="true"></i>
                            <i className="fa fa-star" aria-hidden="true"></i>
                            <i className="fa fa-star" aria-hidden="true"></i>
                            <i className="fa fa-star" aria-hidden="true"></i>
                            <i className="fa fa-star" aria-hidden="true"></i>
                          </div>
                          <span>2 Months ago</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-12">
                  <div className="review-item">
                    <div className="comment">
                      <p><i className="fa fa-quote-left" aria-hidden="true"></i>Support was excellent — they helped us with setup and template design. Now collecting customer Refmex is super easy.<i className="fa fa-quote-right" aria-hidden="true"></i></p>
                    </div>
                    <div className="user">
                      <div className="row">
                        <div className="col-lg-4 col-sm-4 user-img">
                          <img src="images/testimonial3.png" alt="user-img"/>
                        </div>
                        <div className="col-lg-7 col-sm-7 user-txt">
                          <h3>Saiful Alam</h3>
                          <div className="star2">
                            <i className="fa fa-star" aria-hidden="true"></i>
                            <i className="fa fa-star" aria-hidden="true"></i>
                            <i className="fa fa-star" aria-hidden="true"></i>
                            <i className="fa fa-star" aria-hidden="true"></i>
                            <i className="fa fa-star" aria-hidden="true"></i>
                          </div>
                          <span>2 years ago</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}
      {/* REVIEW AREA ENDS */}



{/* analytics section */}
{/* <section id="product">
        <div className="container">
          <div className="row header-text text-center">
            <div className="col-lg-12">
              <h3>ANALYTICS & INSIGHTS <span>D</span>ASHBOARD</h3>
            </div>
          </div>
          <div className="row text-center">
            <div className="col-lg-12">
              <h3 className="mt-3" > “Track, Measure, Improve.”</h3>
            </div>
          </div>
          <div className="row review-pa">
            <div className="col-lg-12">
                <div className="row">
                  <div className="row mb-5 " >
                      <div className="col-12" >
                          <h5> Real-time analytics to guide real business decisions.</h5>
                      </div>
                  </div>
                  <div className="col-lg-8 col-md-7 product-txt">
                   <p className="question-span">
                      <FaChartBar style={{color: "#0553d9", marginRight: "4px"}} /> NPS Scores
                    </p>
                    <p className="question-span">
                      <FaChartLine style={{color: "#0553d9", marginRight: "4px"}} /> Category Trends
                    </p>
                    <p className="question-span">
                      <FaHistory style={{color: "#0553d9", marginRight: "4px"}} /> Refmex over time
                    </p>
                    <p className="question-span">
                      <FaMapMarkerAlt style={{color: "#0553d9", marginRight: "4px"}} /> Location comparisons
                    </p>
                    <p className="question-span">
                      <FaFileExport style={{color: "#0553d9", marginRight: "4px"}} /> CSV/Excel export options
                    </p>
                     
                  </div>
                  <div className="col-lg-4 col-md-4"> 
                    <img  style={{
                        position: 'absolute',
                        top: '50%',
                        right: '0',
                        transform: 'translateY(-50%)',
                        maxHeight: '120%'
                      }} 
                  src="images/track.png"alt="product-img"/>
                  </div>
                </div>
            </div>
          </div>
        </div>
  </section> */}


<section id="product">
  <div className="container">
    <div className="row header-text text-center">
      <div className="col-lg-12">
        <h3 className="text-uppercase heading-mobile" >ANALYTICS & INSIGHTS <span>D</span>ASHBOARD</h3>
      </div>
    </div>
    <div className="row text-center">
      <div className="col-lg-12">
        <h3 className="mt-3">“Track, Reward, Grow.”</h3>
      </div>
    </div>
    <div className="row review-pa">
      <div className="col-12">
        <div className="row align-items-center">
          {/* IMAGE FIRST IN MOBILE */}
          <div className="col-12 col-md-4 order-1 order-md-2 text-center mb-4 mb-md-0">
            <img
              src="images/track.png"
              alt="Analytics Dashboard"
              style={{ maxHeight: '100%', width: '100%' }}
            />
          </div>

          {/* TEXT SECTION */}
          <div className="col-12 col-md-8 order-2 order-md-1 product-txt">
            <h5>Make data-driven decisions with real-time insights.</h5>
            <div className="mt-4">
              <p className="question-span">
                <FaChartBar style={{ color: "#0553d9", marginRight: "4px" }} /> Referral performance trends
              </p>
              <p className="question-span">
                <FaChartLine style={{ color: "#0553d9", marginRight: "4px" }} /> Top referrers & redeemed points
              </p>
              <p className="question-span">
                <FaHistory style={{ color: "#0553d9", marginRight: "4px" }} /> Discount usage tracking
              </p>
              <p className="question-span">
                <FaMapMarkerAlt style={{ color: "#0553d9", marginRight: "4px" }} /> Location-wise comparison
              </p>
              <p className="question-span">
                <FaFileExport style={{ color: "#0553d9", marginRight: "4px" }} /> Export reports (CSV/Excel)
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>


{/* analytics section ends */}
  <section id="overview">
    <div className="container">
        <div className="row header-text text-center">
            <div className="col-lg-12">
                <h3 className="text-uppercase heading-mobile" >FEA<span>T</span>URES</h3>
            </div>
        </div>
        <div className="row review-pa">
            <div className="col-lg-9 col-sm-12 m-auto">
                <div className="row">
                    <div className="col-lg-6 col-sm-6">
                        <div className="over-item txt-right unique-style3">
                            <i className="fa fa-bolt over-i" aria-hidden="true"></i>
                            <div className="break"></div>
                            <h3>Instant Referrals</h3>
                            <p>Launch QR or link-based referral programs that work on any device, without extra setup.</p>
                            <div className="over-btn">
                                <a href="#">Learn More</a>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 col-sm-6">
                        <div className="over-item txt-left unique-style">
                            <i className="fa fa-sliders over-i" aria-hidden="true"></i>
                            <div className="break"></div>
                            <h3>Smart Rewards</h3>
                            <p>Automatically assign loyalty points for successful referrals and manage redemption easily.</p>
                            <div className="over-btn">
                                <a href="#">Learn More</a>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 col-sm-6">
                        <div className="over-item txt-right unique-style2">
                            <i className="fa fa-line-chart over-i" aria-hidden="true"></i>
                            <div className="break"></div>
                            <h3>Custom Campaigns</h3>
                            <p>Create tailored referral and discount campaigns with flexible rules and expiry settings.</p>
                            <div className="over-btn">
                                <a href="#">Learn More</a>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 col-sm-6">
                        <div className="over-item txt-left unique-style4">
                            <i className="fa fa-plug over-i" aria-hidden="true"></i>
                            <div className="break"></div>
                            <h3>Actionable Analytics</h3>
                            <p>Visualize referral flow, ROI, and user behavior from your central dashboard.</p>
                            <div className="over-btn">
                                <a href="#">Learn More</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </section>


 {/* PRICE AREA START */}
      <section id="price">
        <div className="container">
          <div className="row header-text text-center">
            <div className="col-lg-12">
              <h3 className="text-uppercase heading-mobile" >PRI<span>C</span>ING</h3>
            </div>
          </div>
          <div className="row review-pa">
            <div className="col-lg-3 col-sm-6">
              <div className="price-table mob-mar-bottom">
                <h3>Free</h3>
                <h4><sub>$</sub>0<sub>/Month</sub></h4>
                <p><i className="fa fa-check-circle-o" aria-hidden="true"></i> 1 Demo Account </p>
                <p><i className="fa fa-check-circle-o" aria-hidden="true"></i> Without Integration</p>
                <p><i className="fa fa-check-circle-o" aria-hidden="true"></i> Limited Time</p>
                {/* <p><i className="fa fa-check-circle-o" aria-hidden="true"></i>Demo, 1 Location</p> */}
                {/* <p><i className="fa fa-check-circle-o" aria-hidden="true"></i> Demo </p> */}
               <div className="price-btn text-center">
                <a href="#" onClick={() => handlePlanClick('Free')} data-toggle="modal" data-target="#exampleModal">Contact Us</a>
              </div>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6">
              <div className="price-table mob-mar-bottom">
                <h3>Starter</h3>
                <h4><sub>$</sub>19<sub>/Month</sub></h4>
                <p><i className="fa fa-check-circle-o" aria-hidden="true"></i> Single location</p>
                <p><i className="fa fa-check-circle-o" aria-hidden="true"></i> Basic referral setup</p>
                <p><i className="fa fa-check-circle-o" aria-hidden="true"></i> QR code generator</p>
                {/* <p><i className="fa fa-check-circle-o" aria-hidden="true"></i> Prebuilt templates</p> */}
                <p><i className="fa fa-check-circle-o" aria-hidden="true"></i> Email support</p>
                <div className="price-btn text-center">
                  <a href="#" onClick={() => handlePlanClick('Starter')} data-toggle="modal" data-target="#exampleModal">Contact Us</a>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6 mob-mar-bottom">
              <div className="price-table gold-bg">
                <h3 className="gold">Pro</h3>
                <h4><sub>$</sub>49<sub>/Month</sub></h4>
                <p><i className="fa fa-check-circle-o" aria-hidden="true"></i> Multi-location</p>
                {/* <p><i className="fa fa-check-circle-o" aria-hidden="true"></i> Up to 5 locations</p> */}
                 <p><i className="fa fa-check-circle-o" aria-hidden="true"></i> Custom campaigns</p>
                  <p><i className="fa fa-check-circle-o" aria-hidden="true"></i> API access</p>
                   <p><i className="fa fa-check-circle-o" aria-hidden="true"></i> Priority support</p>
                <div className="price-btn gold-bg2 text-center">
                  <a href="#" onClick={() => handlePlanClick('Pro')} data-toggle="modal" data-target="#exampleModal">Contact Us</a>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6">
              <div className="price-table">
                <h3>Enterprise</h3>
                <h4><sub>$</sub>499<sub>/Year</sub></h4>
                {/* <p><i className="fa fa-check-circle-o" aria-hidden="true"></i> Chains & large service brands</p> */}
                <p><i className="fa fa-check-circle-o" aria-hidden="true"></i> Unlimited locations</p>
                <p><i className="fa fa-check-circle-o" aria-hidden="true"></i> Custom API configs</p>
                <p><i className="fa fa-check-circle-o" aria-hidden="true"></i> SLA Support</p>
                <p><i className="fa fa-check-circle-o" aria-hidden="true"></i> Account Manage</p>
               <div className="price-btn text-center">
                <a href="#" onClick={() => handlePlanClick('Enterprise')} data-toggle="modal" data-target="#exampleModal">Contact Us</a>
              </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* PRICE AREA ENDS */}



    
<section id="final-cta" style={{ backgroundColor: '#0553d9',color: '#ffffff',textAlign: 'center',}}>
  <div className="container">
    <div className="row text-center ">
      <div className="col-lg-10 mx-auto">
        <h2
          className="mb-4"
          style={{
            fontSize: '3rem',
            fontWeight: '900',
            color: '#ffffff',
            textShadow: '2px 2px 8px rgba(0, 0, 0, 0.2)',
            fontFamily: "'Poppins', sans-serif",
            lineHeight: '1.2',
          }}
        >
          Start Growing Through Referrals <br /> in Under 15 Minutes
        </h2>
        <p
          className="lead mb-5"
          style={{
            fontSize: '1.25rem',
            color: '#ffffff',
            fontWeight: '500',
          }}
        >
          No setup fees. No complex training.
          <br />
          Just plug in, share, and watch your community grow.
        </p>
        <div
          className="mt-4 d-flex justify-content-center cta-buttons"
          style={{ gap: '20px', flexWrap: 'wrap' }}
        >
        
          <a
            href="#"
            onClick={(e) => { 
              e.preventDefault(); 
              handleOpenRegister('register');
            }}
            style={{
              backgroundColor: '#ffffff',
              color: '#0553d9',
              padding: '14px 28px',
              borderRadius: '30px',
              textDecoration: 'none',
              fontWeight: '700',
              fontSize: '1.1rem',
              boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
              transition: 'all 0.3s ease',
            }}
            onMouseOver={(e) => (e.target.style.transform = 'scale(1.05)')}
            onMouseOut={(e) => (e.target.style.transform = 'scale(1)')}
          >
            Try Refmex Free
          </a>
          <a
            href="https://wa.me/923307776551"
            style={{
              backgroundColor: '#ffffff',
              color: '#0553d9',
              padding: '14px 28px',
              borderRadius: '30px',
              textDecoration: 'none',
              fontWeight: '700',
              fontSize: '1.1rem',
              boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
              transition: 'all 0.3s ease',
            }}
            onMouseOver={(e) => (e.target.style.transform = 'scale(1.05)')}
            onMouseOut={(e) => (e.target.style.transform = 'scale(1)')}
          >
            Talk to Sales
          </a>
        </div>
      </div>
    </div>
  </div>
</section>



     
  <section id="contact">
          <div className="container">
            <div className="row header-text text-center">
              <div className="col-lg-12">
                <h3 className="text-uppercase heading-mobile" >CON<span>T</span>ACT</h3>
              </div>
            </div>
            <div className="row review-pa">
              <div className="col-lg-8 f-text2">
                <div className="accordion" id="accordionExample">
                  <div className="card">
                    <div className="card-header" id="headingOne">
                      <h2 className="mb-0 text-left">
                        <button className="btn btn-link zom" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                          01.How to order properly?
                        </button>
                      </h2>
                    </div>
                    <div id="collapseOne" className="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
                      <div className="card-body">
                      If you need help setting up your campaign or have questions <strong>contact us</strong>. Our support team is happy to guide you through the process.
                      </div>
                    </div>
                  </div>
                  <div className="card">
                    <div className="card-header" id="headingTwo">
                      <h2 className="mb-0 text-left">
                        <button className="btn btn-link collapsed zom" type="button" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                          02.Performance and Security?
                        </button>
                      </h2>
                    </div>
                    <div id="collapseTwo" className="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample">
                      <div className="card-body">
                        For details about our system's performance and security measures, feel free to <strong>get in touch</strong>. We'd be glad to share how we keep your data safe and services running smoothly.
                      </div>
                    </div>
                  </div>
                  <div className="card">
                    <div className="card-header" id="headingThree">
                      <h2 className="mb-0 text-left">
                        <button className="btn btn-link collapsed zom" type="button" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                          03.Which Payment Support?
                        </button>
                      </h2>
                    </div>
                    <div id="collapseThree" className="collapse" aria-labelledby="headingThree" data-parent="#accordionExample">
                      <div className="card-body">
                          We support a variety of payment options. For the most accurate and up-to-date list, please <strong>contact our support team</strong> and we'll assist you right away.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 mobile-space">
          <form onSubmit={handleContactSubmit}>
            <div className="form-group">
              <div className="input-group contact-input mb-3">
                <div className="input-group-prepend">
                  <span className="input-group-text faq-icon">
                    <i className="fa fa-user-o" aria-hidden="true"></i>
                  </span>
                </div>
                <input
                  type="text"
                  name="username"
                  className="form-control box-bg light-v"
                  placeholder="Your Name"
                  value={formData.username}
                  onChange={(e) => setFormData({...formData, username: e.target.value})}
                  required
                />
              </div>
            </div>
            
            <div className="form-group">
              <div className="input-group contact-input mb-3">
                <div className="input-group-prepend">
                  <span className="input-group-text faq-icon">
                    <i className="fa fa-envelope-o" aria-hidden="true"></i>
                  </span>
                </div>
                <input
                  type="email"
                  name="email"
                  className="form-control box-bg light-v"
                  placeholder="Your Email"
                  value={formData.email}
                  onChange={(e) => setFormData({...formData, email: e.target.value})}
                  required
                />
              </div>
            </div>
            
            <div className="form-group">
              <textarea
                name="description"
                className="form-control box-bg"
                placeholder="Your Message"
                rows="4"
                value={formData.description}
                onChange={(e) => setFormData({...formData, description: e.target.value})}
                required
              ></textarea>
            </div>
            
            <div className="con-btn-main">
              <button
                type="submit"
                className="con-btn"
                disabled={isContactSubmitting}
              >
                {isContactSubmitting ? (
                  <>
                    <i className="fa fa-spinner fa-spin"></i> Sending...
                  </>
                ) : (
                  'Submit Now'
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </section>
      
      {/* SUBSCRIBE AREA START */}
    <section id="subscribe">
        <div className="container">
            <div className="row">
                <div className="col-lg-8 m-auto">
                    <div className="sub-main">
                        <div className="row">
                            <div className="col-lg-8 col-md-7">
                                <h3>Stay Connected With Us</h3>
                            </div>
                            <div className="col-lg-3 col-md-5 subscripe-btn">
                                <a href="#" data-toggle="modal" data-target="#exampleModal2">Subcribe Us</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

              {/* Contact Modal */}
<div className={`modal fade ${showModal ? 'show' : ''}`} id="exampleModal" tabIndex="-1" role="dialog" 
     style={{ display: showModal ? 'block' : 'none', backgroundColor: showModal ? 'rgba(0,0,0,0.5)' : 'transparent' }}>
  <div className="modal-dialog" role="document">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title">
          {formData.plan ? `Interested in ${formData.plan} Plan` : 'Contact Us'}
        </h5>
        {/* <button type="button" className="close" onClick={handleCloseModal} aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button> */}
      </div>
      <form onSubmit={handleContactSubmit}>
        <div className="modal-body">
          <div className="input-group contact-input mb-3">
            <div className="input-group-prepend">
              <span className="input-group-text faq-icon">
                <i className="fa fa-user-o" aria-hidden="true"></i>
              </span>
            </div>
            <input
              type="text"
              className="form-control box-bg"
              placeholder="Your Name"
              value={formData.username}
              onChange={(e) => setFormData({...formData, username: e.target.value})}
              required
            />
          </div>
          
          <div className="input-group contact-input mb-3">
            <div className="input-group-prepend">
              <span className="input-group-text faq-icon">
                <i className="fa fa-envelope-o" aria-hidden="true"></i>
              </span>
            </div>
            <input
              type="email"
              className="form-control box-bg"
              placeholder="Your Email"
              value={formData.email}
              onChange={(e) => setFormData({...formData, email: e.target.value})}
              required
            />
          </div>
          
          <div className="form-group">
            <textarea
              className="form-control box-bg"
              placeholder="Your Message"
              rows="3"
              value={formData.description}
              onChange={(e) => setFormData({...formData, description: e.target.value})}
              required
            ></textarea>
          </div>
          
          {formData.plan && (
            <input type="hidden" name="plan" value={formData.plan} />
          )}
        </div>
        <div className="modal-footer">
          {/* <button type="button" className="dropboxx" onClick={handleCloseModal}>
            Close
          </button> */}
          <button
            type="submit"
            className="dropboxx2"
            disabled={isContactSubmitting}
          >
            {isContactSubmitting ? 'Sending...' : 'Send Message'}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>




           <div className="modal fade show" id="exampleModal2" tabIndex="-1" role="dialog">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <form onSubmit={handleSubmit}>
                            <div className="modal-header">
                                <h5 className="modal-title">Subscription</h5>
                                {/* <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">×</span>
                                </button> */}
                            </div>
                            <div className="modal-body">
                                <div className="input-group contact-input mb-3">
                                    <input
                                        type="email"
                                        className="form-control box-bg"
                                        placeholder="Email Address"
                                        aria-label="Email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        required
                                    />
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="submit" className="dropboxx2" disabled={isSubmitting}>
                                    {isSubmitting ? (
                                        <span>
                                            <i className="fa fa-spinner fa-spin"></i> Submitting...
                                        </span>
                                    ) : (
                                        'Subscribe'
                                    )}
                                </button>
                            </div>
                        </form>

                    </div>
                </div>
            </div>

    {/* SUBSCRIBE AREA END */}
    <Footer/>
</div>
    </>
)
};

export default Homepage;